export const shortenString = (str: string, maxLength: number) =>
  str?.length > maxLength ? `${str.slice(0, maxLength)}...` : str;

export const isValidEmail = (mail: string) =>
  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail);

export const buildCallbackURL = (locationId: string) => {
  return `https://app.reviewcircle.com/#/request/location/${locationId}/callback`;
};
